<Boundary>
  <div bind:this={wrapper}>
    <CardsComponentWrapper style="
      {buildCssPadding(tab.padding)}
      {buildCssMargin(tab.padding)}
      {buildCssBackground(tab.background)}
    " {editorOptions}>
      {#if contentStore && $contentStore}
        <CardsSections parentSequenceId={sequenceId} sections={$contentStore.sections} updater={(sections) => tab.sections = sections} />      
      {/if}
    </CardsComponentWrapper>
  </div>
</Boundary>

<style>*, *::before, *::after {
  box-sizing: border-box;
}</style>

<script lang="ts">import { YinzCamCardsServiceToken } from "yinzcam-cards";
import CardsSections from "./CardsSections.svelte";
import { buildCssPadding, buildCssBackground, buildCssMargin } from '../utilities/index';
import { getContext, onMount, setContext } from "svelte";
import { CardsPageContextKey, CardsTabContextKey } from "./context";
import { CardsDataSourceManager } from "./CardsDataSourceManager";
import ROOT from "../../../inversify.config";
import { writable } from "svelte/store";
import { getToken } from "inversify-token";
import { Boundary } from '@crownframework/svelte-error-boundary/src/index';
import { JanusModeContextManagerToken } from "../../../js/mode";
import { MergedYinzCamAPIRequestParameterComponent } from "yinzcam-api";
import { AbstractReactiveMicrocomponent, ManualPassthrough } from "yinzcam-rma";
import _ from "lodash";
import CardsComponentWrapper from './CardsComponentWrapper.svelte';
import "./CardsEditorInterfaces";
import { CARDS_TAB_SCHEMA } from "./CardsEditorComponentSchemata";
export let parentSequenceId = null;
export let sequenceId = "";
export let tab;
export let updater;
const cardsService = getToken(ROOT, YinzCamCardsServiceToken);
const dataSourceManager = new CardsDataSourceManager(ROOT);
const pageContext = getContext(CardsPageContextKey);
const defaultParamsComp = pageContext.defaultParamsComp;
const modeParamsComp = getToken(ROOT, JanusModeContextManagerToken).getMergedRequestParameterComponent();
const pageParamsComp = new ManualPassthrough({ name: `CardsTab_${tab.id}_PageParams`, saveToLocalStorage: false }, { params: pageContext.query });
const internalParamsComp = new ManualPassthrough({ name: `CardsTab_${tab.id}_InternalParams`, saveToLocalStorage: false }, { params: {} });
const mergedApiParamsComp = new MergedYinzCamAPIRequestParameterComponent({ name: `CardsTab_${tab.id}_MergedApiParams`, saveToLocalStorage: false }, defaultParamsComp, modeParamsComp, pageParamsComp, internalParamsComp);
const pathParamsMappingComp = pageContext.pathParamsMappingComp;
const mergedParamsComp = new class extends AbstractReactiveMicrocomponent {
    constructor() {
        super(...arguments);
        this.lastParams = undefined;
    }
    async update($control, $apiParams, $pathParamsMap) {
        const newParams = $apiParams === null || $apiParams === void 0 ? void 0 : $apiParams.params;
        //console.log('TAB API PARAMS', newParams);
        for (let [i, param] of $pathParamsMap.entries()) {
            if (!param)
                continue;
            const subst = newParams[`path${i}`];
            if (!subst)
                continue;
            newParams[param] = subst;
        }
        if (this.lastParams === newParams || _.isEqual(this.lastParams, newParams)) {
            throw new Error("params have not changed");
        }
        this.lastParams = newParams;
        return newParams;
    }
}({ name: `CardsTab_${tab.id}_MergedParams`, saveToLocalStorage: false, expectThrowFromUpdate: true }, mergedApiParamsComp, pathParamsMappingComp);
const mergedParamsStore = mergedParamsComp.store;
const setParam = function (key, value) {
    if (!key) {
        return;
    }
    let apiParams = internalParamsComp.getValue();
    if (!(apiParams === null || apiParams === void 0 ? void 0 : apiParams.params)) {
        apiParams = { params: {} };
    }
    if (!value) {
        delete apiParams.params[key];
    }
    else {
        apiParams.params[key] = value;
    }
    internalParamsComp.setValue(apiParams);
};
const scrollContainer = writable(document.body);
setContext(CardsTabContextKey, { dataSourceManager, mergedParamsComp, setParam, scrollContainer });
let contentStore;
let wrapper;
$: fragmentId = tab === null || tab === void 0 ? void 0 : tab.fragmentId;
$: sections = tab === null || tab === void 0 ? void 0 : tab.sections;
$: if (sections) {
    try {
        if (fragmentId) {
            console.log('cannot define both sections and fragment ID for a tab');
        }
        else {
            contentStore = writable(tab);
        }
    }
    finally { }
}
$: if (fragmentId) {
    try {
        if (sections) {
            console.log('cannot define both sections and fragment ID for a tab');
        }
        else {
            contentStore = cardsService.getCardsFragment(fragmentId).store;
        }
    }
    finally { }
}
$: if (contentStore && !_.isNil($contentStore) && mergedParamsStore && !_.isNil($mergedParamsStore)) {
    try {
        dataSourceManager.setDataSources($contentStore.sources, $mergedParamsStore);
    }
    finally { }
}
let editorOptions;
$: editorOptions = {
    parentSequenceId,
    sequenceId,
    componentId: tab.id,
    component: tab,
    componentTypeName: 'Tab',
    primaryColor: 'gold',
    reverseTextColor: 'black',
    childrenKey: 'sections',
    configSpec: CARDS_TAB_SCHEMA,
    allowChildren: true,
    allowDeletion: false,
    allowDuplication: false,
    allowMovement: false,
    updater
};
function findScrollContainer() {
    let el = wrapper;
    while (el = el.parentElement) {
        let style = getComputedStyle(el);
        if (String(style === null || style === void 0 ? void 0 : style.overflow).toLowerCase() === 'auto') {
            scrollContainer.set(el);
            break;
        }
    }
}
onMount(() => {
    findScrollContainer();
});
</script>
